import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import PublicLayout from "@/components/public/PublicLayout";

const COPY = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "This page is a DRAFT / TBD placeholder for Le Collectif Horloger's privacy policy.",
      "It is not final counsel and does not create legal rights or obligations.",
      "Contact the house for current privacy practices until this page is published.",
    ],
  },
  terms: {
    title: "Terms of Use",
    body: [
      "This page is a DRAFT / TBD placeholder for site terms of use.",
      "It is not final counsel and does not create legal rights or obligations.",
      "Merch checkout and account features remain subject to policies the house will publish here.",
    ],
  },
  shipping: {
    title: "Shipping",
    body: [
      "This page is a DRAFT / TBD placeholder for shipping information.",
      "It is not final counsel. Exact carriers, timelines, and fees will be confirmed by the house per order.",
      "Watch purchases and deposits are not completed via automated checkout on this site until further notice.",
    ],
  },
  returns: {
    title: "Returns",
    body: [
      "This page is a DRAFT / TBD placeholder for returns information.",
      "It is not final counsel and does not invent return windows, restocking fees, or guarantees.",
      "Authenticated watch transactions follow house process confirmed in writing per sale.",
    ],
  },
};

export default function LegalStub() {
  const { page: pageParam } = useParams();
  const location = useLocation();
  const fromPath = (location.pathname || "").replace(/^\//, "").split("/")[0];
  const page = pageParam || fromPath;
  const meta = COPY[page] || {
    title: "Policy",
    body: ["This draft policy page is not yet published."],
  };
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-5 py-14" data-testid={`legal-stub-${page || "unknown"}`}>
        <div className="text-[10px] tracking-[0.25em] uppercase text-amber-400/90 mb-3">Draft / TBD — not final counsel</div>
        <h1 className="text-3xl font-semibold text-[var(--text)]">{meta.title}</h1>
        <div className="mt-6 space-y-4 text-[var(--text-2)] leading-relaxed">
          {meta.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
        <p className="mt-8 text-sm text-[var(--muted)]">
          Questions: <a className="text-[#c9a86a]" href="mailto:team@lecollectifhorloger.com">team@lecollectifhorloger.com</a>
          {" · "}
          <Link to="/" className="text-[#c9a86a]">Home</Link>
        </p>
      </section>
    </PublicLayout>
  );
}
